import * as React from 'react'
import HowItWorksIcon from './Icon'
import HowItWorksBackground from './Background'
import {
  Row,
  Column,
  Text,
  Bold,
  List,
  styleguide,
  Layout,
  DotDivider,
} from 'styleguide'
import styled, { css } from 'react-emotion'

const StepCell = styled(Column)`
  position: relative;
  padding: ${styleguide.spacing.l};
  border-bottom: 1px solid ${styleguide.colors.foreground};
  ${styleguide.desktop(
    css`
      border: 0;
      border-right: 1px solid ${styleguide.colors.foreground};
    `
  )};

  &:last-child {
    border: 0;
  }
`

const IconContainer = styled(Row)`
  padding: 60px;
  position: relative;
  z-index: 3;
`

const StepTitle = styled(Text)`
  margin-bottom: 20px;
`

const Step = ({ step }) => (
  <StepCell grow justify="start">
    <Column
      grow
      justify="start"
      css={`
        ${styleguide.desktop(
          css`
            margin: 0 ${styleguide.spacing.m};
          `
        )};
        position: relative;
        &:last-child {
          margin-right: 0px;
        }
      `}>
      <IconContainer>
        <HowItWorksBackground bg={step.icon} />
        <HowItWorksIcon icon={step.icon} />
      </IconContainer>
      <StepTitle centered bold>
        {step.stepNum}. {step.title}
      </StepTitle>
      <List subtext list={step.details} />
    </Column>
  </StepCell>
)

const step1 = {
  stepNum: 2,
  icon: 'survey',
  title: 'Attach Surveys',
  details: [
    <Text pt subtext>
      Theme Scoops questions to match your site, and create as many surveys as
      you want on Scoops.
    </Text>,
    <Text pt subtext>
      When you're ready to take a survey live, link it to an event sent from
      your app, like <Bold>clicked-signup</Bold>. When a user triggers an event
      for a survey they haven't answered before, they'll be presented with your
      survey.
    </Text>,
  ],
}
const step2 = {
  stepNum: 1,
  icon: 'api',
  title: 'Trigger an Event',
  details: [
    <Text pt subtext>
      Ask a developer to trigger an event, like <Bold>clicked-signup</Bold>,
      with our JavaScript API when you want the survey to appear.
    </Text>,
    <Text pt subtext>
      Don't worry about triggering too many events! We'll make sure a user
      receives no more than one survey and make sure it's a question they
      haven't answered before.
    </Text>,
  ],
}
const step3 = {
  stepNum: 3,
  icon: 'bar',
  title: 'Get Data',
  details: [
    <Text pt subtext>
      See your results day by day, or week by week.
    </Text>,
    <Text pt subtext>
      Release a new feature, and watch the change in your users' thoughts and
      opinions!
    </Text>,
  ],
}

const steps = [step2, step1, step3]

const mapSteps = (step, i) => <Step key={i} step={step} />

const Container = styled(Row)`
  margin-top: 6px;
  border-radius: ${styleguide.radii.outer};
  border: 1px solid ${styleguide.colors.foreground};
  z-index: 3;
`

export default props => (
  <Layout size="large">
    <Column>
      <Row
        align="start"
        css={`
          min-width: 50%;
        `}>
        <Column>
          <Text subtitle bold serif centered>
            How it Works
          </Text>
          <DotDivider centered />
          <Container align="stretch" justify="space-between" break>
            {steps.map(mapSteps)}
          </Container>
        </Column>
      </Row>
    </Column>
  </Layout>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/index.js